module.exports = __webpack_public_path__ + "img/login-header.4bd7ee79.png";